import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { MdInstallMobile } from 'react-icons/md';

const InstallPWA = () => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);

            // Check if user has already ignored the prompt in this session
            const isIgnored = sessionStorage.getItem('pwaPromptIgnored');
            if (!isIgnored) {
                setOpen(true);
            }
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const handleInstall = (e) => {
        e.preventDefault();
        if (!promptInstall) return;

        promptInstall.prompt();
        promptInstall.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the PWA install');
            } else {
                console.log('User dismissed the PWA install');
            }
            setOpen(false);
        });
    };

    const handleClose = () => {
        setOpen(false);
        // Optionally store in session storage to not bug the user again in the same session
        sessionStorage.setItem('pwaPromptIgnored', 'true');
    };

    if (!supportsPWA) return null;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="install-pwa-dialog-title"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="install-pwa-dialog-title">
                <Box display="flex" alignItems="center" gap={1}>
                    <MdInstallMobile size={24} color="#1e3a8a" />
                    <Typography variant="h6">Install Burray HR Admin Software</Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    Install our app on your home screen for quick and easy access to the Burray HR Admin Software.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <Button onClick={handleClose} color="inherit">
                    Not Now
                </Button>
                <Button
                    onClick={handleInstall}
                    variant="contained"
                    sx={{
                        backgroundColor: '#1e3a8a',
                        '&:hover': {
                            backgroundColor: '#1e40af'
                        }
                    }}
                >
                    Install App
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InstallPWA;
